import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AtlCardCarouselProps, CardTags } from './card.types.ts';
import { PaginationEnums } from '../pagination/index.ts';
import { enumAttributeConverter } from '../enum-types.ts';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlantisEvent } from '../helpers.ts';

import Styles from './card-carousel.scss?inline';

@customElement(CardTags.CardCarousel)
export class AtlCardCarousel
   extends LitElement
   implements AtlCardCarouselProps
{
   static styles = [
      ...getGlobalStyleSheets(),
      Styles
   ];

   @property({ type: Number })
   pages: number;

   @property({ type: Number })
   firstRenderActivePage: number;

   @property({ 
      type: String,
      converter: enumAttributeConverter(
         PaginationEnums.PaginationType,
         PaginationEnums.PaginationType.Numeric
      )
   })
   type: PaginationEnums.PaginationType;

   onSlotChange(e: AtlantisEvent<Event, HTMLSlotElement>) {
      const assignedNodes = e.target.assignedNodes({
         flatten: true,
      }) as HTMLElement[];

      const storedCardElements = this.getAllCardElements(assignedNodes);

      storedCardElements.forEach((card) => {
         card.setAttribute('internalClassName', 'shadow-none');
         card.style.setProperty('--tti-card-border-width', '0');
      });
   }

   getAllCardElements = (nodes: HTMLElement[]): HTMLElement[] => {
      let cardElements: HTMLElement[] = [];
      nodes.forEach((node) => {
         if (node.nodeName.includes('CARD')) {
            cardElements.push(node);
         } else if (node instanceof HTMLElement) {
            cardElements = cardElements.concat(
               this.getAllCardElements(
                  Array.from(node.children) as HTMLElement[]
               )
            );
         }
      });
      return cardElements;
   };

   render() {
      return html`
         <div class="carousel" part="carousel">
            <div class="carousel-content">
               <slot name="contentSlot" @slotchange=${this.onSlotChange}></slot>
            </div>
            <atlantis-pagination
               type=${this.type}
               pages="${this.pages}"
               firstrenderactivepage="${this.firstRenderActivePage}"
            >
            </atlantis-pagination>
         </div>
      `;
   }
}
